export enum EAuthActions {
  SIGN_IN = 'SIGN_IN',
  SEND_OTP_LOGIN = 'SEND_OTP_LOGIN',
}
